import { defineNuxtPlugin } from '#imports'

import { NUXT_STATE_KEY } from './constants'
import { getRequestLocale } from './utils/getRequestLocale'

export default defineNuxtPlugin({
  name: 'i18nLocale',
  setup: (nuxt) => {
    if (nuxt.ssrContext) {
      const locale = getRequestLocale(nuxt.ssrContext.event)

      // eslint-disable-next-line no-param-reassign
      nuxt.payload.state[NUXT_STATE_KEY] = {
        locale,
      }
    }
  },
})
